import axios from "axios";

import config from "@/config";

import { getAccessToken } from "./auth";

const api = axios.create({
  baseURL: config.apiUrl,
});

api.interceptors.request.use(async (reqConfig) => {
  if (reqConfig.headers.Authorization) return reqConfig;
  try {
    const token = await getAccessToken();
    reqConfig.headers.Authorization = `Bearer ${token}`;
  } catch {
    // Auth not ready yet (initial load) — let the request go without a token.
  }
  return reqConfig;
});
export default api;
